import { render, staticRenderFns } from "./NaviHeaderWrapper.vue?vue&type=template&id=2fcec994"
import script from "./NaviHeaderWrapper.vue?vue&type=script&lang=ts"
export * from "./NaviHeaderWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports